import { Factory } from '../../services/Factory';

export interface IJsonViewerScope extends angular.IScope {
json: string
}

export interface IJsonViewerAttributes extends angular.IAttributes {
buttonText: string
}

export class JsonViewer implements angular.IDirective {
public restrict: string = 'E';
public link: (scope: ITooltipScope, element: angular.IAugmentedJQuery, attrs: IJsonViewerAttributes) => void;
public template: string;
public scope = {json: '=ngModel'};
public require = ['ngModel'];

constructor($uibModal) {
this.template = `<div class="btn-link"></div>`;
this.link = (scope: IJsonViewerScope, element: angular.IAugmentedJQuery, attrs: IJsonViewerAttributes) => {
  // With replace:true gone, element is the <iio-json-viewer> wrapper.
  // Append the label text into the inner .btn-link div so Bootstrap styles apply.
  element.find('.btn-link').append(attrs.buttonText ? attrs.buttonText : "View");
  element.click(() => {
    scope.instance = $uibModal.open({
      backdrop: true,
      keyboard: true,
      backdropClick: true,
      templateUrl: 'partials/controls/json-viewer.html',
      scope: scope
    });
  });
}
}
}

frontendApp.directive("iioJsonViewer", ["$uibModal", Factory.Create(JsonViewer)]);
